import { toastController, modalController } from "@ionic/vue";
import { addIcons } from 'ionicons';
import {
    warningOutline,
    informationCircleOutline,
    closeOutline,
    checkmarkCircleOutline
} from 'ionicons/icons';
import { ref } from 'vue';
import {useAuth} from '@/composables/useAuth.ts'

addIcons({
    'warning-outline': warningOutline,
    'information-circle-outline': informationCircleOutline,
    'checkmark-circle-outline': checkmarkCircleOutline,
    'close-outline': closeOutline,
});

interface toastOptions {
    title?: string
    message: string
    preset: 'error' | 'info' | 'success',
    closeAfterDuration?: boolean,
    closeButton?: boolean,
}

const iconMap: Record<toastOptions['preset'], string> = {
    error: 'warning-outline',
    info: 'information-circle-outline',
    success: 'checkmark-circle-outline'
}

export const toast = async (options: toastOptions) => {
    const {
        closeAfterDuration = true,
        closeButton = false
    } = options;

    const buttons = []
    if (closeButton) {
        buttons.push({
            icon: 'close-outline',
            role: 'cancel',
        })
    }
    const t = await toastController.create({
        header: options.title,
        message: options.message,
        duration: closeAfterDuration ? 3000 : undefined,
        position: 'bottom',
        cssClass: `toast ${options.preset}`,
        icon: iconMap[options.preset],
        buttons: buttons
    });
    await t.present()
}

export const activeModalRef = ref<HTMLIonModalElement | null>(null);

export const closeSessionModal = async () => {
    if (activeModalRef.value) {
        await activeModalRef.value.dismiss();
        activeModalRef.value = null;

        const { closeSessionWarning } = useAuth();
        closeSessionWarning();
    }
};

interface ModalOptions {
    component: any;
    componentProps?: Record<string, any>;
    backdropDismiss?: boolean;
    keyboardClose?: boolean;
    cssClass?: string | string[];
}

export const showModal = async (options: ModalOptions) => {
    await closeSessionModal();
    let classes: Array<string> = []
    if (options.cssClass) {
        classes = Array.isArray(options.cssClass) ? options.cssClass : [options.cssClass]
    }

    const modal = await modalController.create({
        component: options.component,
        backdropDismiss: options.backdropDismiss ?? false,
        keyboardClose: options.keyboardClose ?? false,
        componentProps: options.componentProps,
        cssClass: ["suite-modal-overlay", ...classes],
    });

    activeModalRef.value = modal;

    await modal.present();
    return modal;
};